import Cookies from "js-cookie";

export default class AdvertisementCookie {
  static showBannerAd() {
    if (Cookies.get("_sda") === "false" && Cookies.get("shva") === "1") {
      return false;
    }
    return true;
  }
}